import { render, staticRenderFns } from "./ejemplos_api_es.vue?vue&type=template&id=6f3a35c4&scoped=true&"
import script from "./ejemplos_api_es.vue?vue&type=script&lang=js&"
export * from "./ejemplos_api_es.vue?vue&type=script&lang=js&"
import style0 from "./ejemplos_api_es.vue?vue&type=style&index=0&id=6f3a35c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3a35c4",
  null
  
)

export default component.exports